import { useId } from "react";

import { clsxMerge } from "shared/lib/helpers";

interface MeetingNotesFieldPropsI {
  value: string;
  error?: boolean;
  disabled?: boolean;
  onChange: (value: string) => void;
}

/**
 * GLE-8421: the scheduling-link modal's notes textarea, shared by
 * ConfirmDetectedStep and AutoSyncStep, with its label and error wired to it.
 */
export const MeetingNotesField = ({
  value,
  error = false,
  disabled = false,
  onChange,
}: MeetingNotesFieldPropsI) => {
  const fieldId = useId();
  const errorId = `${fieldId}-error`;

  return (
    <section className="mb-6">
      <label htmlFor={fieldId} className="label">
        <span className="typography-body-4-medium">
          Notes for Account Executive
        </span>
      </label>

      <textarea
        id={fieldId}
        name="notes"
        value={value}
        onChange={(ev) => onChange(ev.target.value)}
        rows={5}
        maxLength={2000}
        placeholder="Add notes about the meeting, lead qualification, or any other relevant information..."
        disabled={disabled}
        aria-required
        aria-invalid={error}
        aria-describedby={error ? errorId : undefined}
        className={clsxMerge(
          "textarea w-full resize-none rounded-lg bg-black/5 p-4 typography-body-4 focus:outline-none",
          error && "textarea-bordered border-error-content"
        )}
      />

      {error && (
        <p id={errorId} className="mt-1 text-sm text-error-content">
          Please provide notes for the Account Executive
        </p>
      )}
    </section>
  );
};
